var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"page-result"},[_vm._v("Showing "+_vm._s(_setup.rangeMin)+"-"+_vm._s(_setup.rangeMax)+" of "+_vm._s(_vm.data.total)+" results")])
}
var staticRenderFns = []

export { render, staticRenderFns }